import { render, staticRenderFns } from "./recordForm.vue?vue&type=template&id=2f5bdb4c&scoped=true&"
import script from "./recordForm.vue?vue&type=script&lang=js&"
export * from "./recordForm.vue?vue&type=script&lang=js&"
import style0 from "./recordForm.vue?vue&type=style&index=0&id=2f5bdb4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5bdb4c",
  null
  
)

export default component.exports